import React, { useEffect, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
const Recaptcha = ({ handleChange, onExpired, remount }) => {
  const [resetKey, setResetKey] = useState(0)

  useEffect(() => {
    if (remount) {
      setResetKey((prev) => prev + 1)
      onExpired()
    }
  }, [remount])
  const handleRecaptchaChange = (token) => {
    handleChange(token)
    setTimeout(() => {
      setResetKey((prev) => prev + 1)
      onExpired()
    }, 30000)
  }

  return (
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      onChange={handleRecaptchaChange}
      onExpired={onExpired}
      key={resetKey}
    />
  )
}

export default Recaptcha
